import { render, staticRenderFns } from "./InvoiceGeneration.vue?vue&type=template&id=130bd2a8"
import script from "./InvoiceGeneration.vue?vue&type=script&lang=js"
export * from "./InvoiceGeneration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports